namespace GeniuzPOS.AdvPromo {
    export class PsAdvPromoHd4Columns {
        static columnsKey = 'AdvPromo.PsAdvPromoHd4';
    }
}
